
<style>
  .form-material select, .form-material input, .form-material textarea, languageSelector select {
    width: 100%;
    font-size:14px;
  }

.form-material select {
  font-size:14px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.languageContainer {
  display:block;
  margin-bottom:10px;
}

.globalContainer {
  display:block;
  margin-bottom:10px;
}

</style>

<div style="height: 92vh;">
<app-modal-header [headerTitle]="'Propers'"></app-modal-header>

<div *ngIf="proper != null">

  <div mat-dialog-content style="max-height: 81vh;"> 

    <div  style="border-bottom:1px solid gray">All Languages</div>
    <div class="globalContainer">

      <div class="row">
  
          <div class="col-sm-5"> 

              <div class="form-material">
                {{proper.Id}}
                <label for="">Proper Id</label>
              </div> 
          </div>


          <div class="col-sm-2"> 
              <div class="form-material">
                {{proper.ProperNumber}}
                <label for="">Proper Number</label>
              </div> 
            </div>
  
            <div class="col-sm-2"> 
              <div class="form-material">
                {{proper.Weekday}}
                <label for="">Proper Weekday</label>
              </div> 
              </div>

          <div class="col-sm-3" *ngIf="proper.IsProofed == true"> 
            <div class="form-material">
              {{proper.ProofedByName}}
              <label for="">Proofed</label>
            </div> 
          </div>

              
                

        <div class="col-sm-12"> 
           
 
          <mat-tab-group style="width:70vwX">

         
            <mat-tab label="Mappings" *ngIf="proper.Id != null">
              <ng-template matTabContent>
                
                <div class="mappings">
                  <app-mappings [properId]="proper.Id"></app-mappings> 
                </div>
    
              </ng-template>
            </mat-tab> 
    
            <mat-tab label="Propers" *ngIf="proper.Id != null">
                <ng-template matTabContent>
                  
                  <div class="propers">
                    <app-service-edit-view-available-propers [properId]="proper.Id"></app-service-edit-view-available-propers>
                  </div>
      
                </ng-template>
              </mat-tab> 
    
          </mat-tab-group> 
    





        </div> 

      </div>

    </div> 
      
    <div mat-dialog-actions class="float-right">
 
      <button mat-button (click)="cancel()"     class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Close</button> 
      <button mat-button (click)="save(false)"  *ngIf="proper.IsProofed==true" class="btn btn-sm btn-outline-primary" style="margin-right:10px">Clear Proof</button>
      <button mat-button (click)="save(true)"   *ngIf="proper.IsProofed==false" class="btn btn-sm btn-outline-primary">Proof</button>

    </div>

  </div>

</div>

</div>
 